import { watch } from 'vue';
import { installLocale, setLocale } from '@comein/comein-ui-plus';

/**
 * 将 BRM 项目 vue-i18n 的 locale 映射为 ComeIn UI Plus 内置语言键。
 * ComeIn UI Plus 使用 zh-cn / en / zh-hk（见包内 locale 资源）。
 * @param {string} [i18nLocale] - vue-i18n 语言，如 zh-CN、en-US、zh-TW
 * @returns {'zh-cn'|'en'|'zh-hk'}
 */
export function mapI18nLocaleToComeinUiPlus(i18nLocale) {
  if (!i18nLocale) {
    return 'zh-cn';
  }
  if (i18nLocale === 'en-US') {
    return 'en';
  }
  if (i18nLocale === 'zh-TW') {
    return 'zh-hk';
  }
  return 'zh-cn';
}

/**
 * 从 vue-i18n 实例读取当前 locale 字符串（兼容 Ref 与 plain string）。
 * @param {import('vue-i18n').I18n} i18nInstance
 * @returns {string}
 */
function getCurrentI18nLocale(i18nInstance) {
  const loc = i18nInstance.global.locale;
  if (typeof loc === 'object' && loc !== null && 'value' in loc) {
    return loc.value;
  }
  return loc;
}

/**
 * 注册 ComeIn UI Plus 国际化，并与 vue-i18n 语言保持同步（含切换语言、多标签 cookie 同步等场景）。
 * 须在 `app.use(i18n)` 之后、挂载任意使用 ComeIn UI Plus 文案的组件之前调用一次。
 * @param {import('vue').App} app
 * @param {import('vue-i18n').I18n} i18nInstance
 */
export function initComeinUiPlusLocaleSync(app, i18nInstance) {
  const comeinLang = mapI18nLocaleToComeinUiPlus(getCurrentI18nLocale(i18nInstance));
  installLocale(app, { lang: comeinLang });

  const apply = () => {
    const raw = getCurrentI18nLocale(i18nInstance);
    const next = mapI18nLocaleToComeinUiPlus(raw);
    void setLocale(next);
  };

  watch(i18nInstance.global.locale, apply);
}
